import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SlWapiService } from '../model/api-services/sl-wapi.service';
import * as DetectBrowser from 'detect-browser';


@Injectable({
  providedIn: 'root'
})
export class DMIGuard implements CanActivate {

  constructor(
    private router: Router,
    private wapi: SlWapiService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): boolean {
    const browser = DetectBrowser.detect();

    switch (browser && browser.name) {
      case 'ie':

      //return false;
    }
    let dmiCookie = this.wapi.GetDMICookie();
    if(dmiCookie === '') {
      if(document.location.href.indexOf('https://localhost:')===0) {
        dmiCookie = this.wapi.GetAppCookie();
      }
    }
    if (dmiCookie.length > 0) {
      if (this.wapi.HasSession()) {
        return true;
      } else {
        this.wapi.AuthenticateToken(dmiCookie).then(() => {
          this.router.navigateByUrl(routerState.url);
          return true;
        }).catch(() => {
          this.wapi.SetAuthTo(decodeURI(routerState.url));
          this.router.navigate(['/login']);
        });
        return false;
      }
    } else {

      this.wapi.SetAuthTo(decodeURI(routerState.url));
      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login']);
      return false;
    }
  }

}
